import React from 'react';
import { Provider } from 'react-redux';

import { ConfigProvider } from 'ha/helpers/config';
import { IntlProvider, IntlObject } from 'ha/i18n';
import { ServicesProvider } from 'ha/services/ServicesContext';
import { AppServices } from 'ha/services/getAppServices';
import { theme, themeNext } from '@hbf/dsl';
import { ThemeProvider } from '@mui/material';

import { Store } from 'redux';
import { Config } from 'ha/config';

import { ErrorBoundary } from 'ha/components/ErrorBoundary';
import { getFeatureFlags } from 'ha/modules/FeatureFlags';

interface Props {
  store: Store;
  config: Config;
  intl: IntlObject;
  services: AppServices;
}

const AppContextProvider: React.FC<Props> = ({
  store,
  config,
  intl,
  services,
  children,
}) => {
  const { dslNext } = getFeatureFlags(store.getState());
  return (
    <ThemeProvider theme={dslNext === 'on' ? themeNext : theme}>
      <Provider store={store}>
        <ConfigProvider value={config}>
          <ServicesProvider value={services}>
            <IntlProvider value={intl}>
              <ErrorBoundary>{children}</ErrorBoundary>
            </IntlProvider>
          </ServicesProvider>
        </ConfigProvider>
      </Provider>
    </ThemeProvider>
  );
};

export { AppContextProvider };
